// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentCertificationIndex } = lazily(() => import('pages/back-office/content-management/certification'))

const contentCertificationRoutes: IRoute[] = [
  {
    path: CONTENT_URL.CERTIFICATION,
    component: ContentCertificationIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: { label: 'contentManagementCertification.certification', accessCodes: [554] },
    },
  },
]

export { contentCertificationRoutes }
